import { fromJS, Map } from 'immutable'
import { handleActions } from 'redux-actions'
import { PDF_REPORTS } from 'constants/appRouting'
import Psfs from 'lib/psfs/Psfs'
import ActionHelper from 'helpers/action'
import { createTableObj } from 'helpers/common'

// constants
export const CLEAR_STORE = 'pdfReports/CLEAR_STORE'
export const SET_TABLE_PSFS = 'pdfReports/SET_TABLE_PSFS'
export const FETCH_PDF_REPORTS_TABLE_DATA =
  'pdfReports/FETCH_PDF_REPORTS_TABLE_DATA'
export const [
  FETCH_PDF_REPORTS_TABLE_DATA_SUCCESS,
  FETCH_PDF_REPORTS_TABLE_DATA_FAILURE,
] = [
  `${FETCH_PDF_REPORTS_TABLE_DATA}_SUCCESS`,
  `${FETCH_PDF_REPORTS_TABLE_DATA}_FAILURE`,
]

// actions
export const clearStore = ActionHelper.createActionObj(CLEAR_STORE)
export const setTablePsfs = ActionHelper.createActionObj(SET_TABLE_PSFS)
export const fetchPdfReportsTableData = ActionHelper.createActionObj(
  FETCH_PDF_REPORTS_TABLE_DATA,
)

// store
const initialState = () =>
  fromJS({
    isLoading: false,
    tableData: createTableObj(),
    tablePsfs: new Psfs(PDF_REPORTS),
  })

const pdfReports = handleActions(
  {
    [SET_TABLE_PSFS]: (state, action) => state.set('tablePsfs', action.payload),
    [FETCH_PDF_REPORTS_TABLE_DATA]: state => state.set('isLoading', true),
    [FETCH_PDF_REPORTS_TABLE_DATA_SUCCESS]: (state, action) =>
      state.set('tableData', Map(action.payload)).set('isLoading', false),
    [FETCH_PDF_REPORTS_TABLE_DATA_FAILURE]: state =>
      state.set('isLoading', false),
    [CLEAR_STORE]: () => initialState(),
  },
  initialState(),
)

export default pdfReports
